<template>
  <div class="header">
    <el-avatar class="avatar" :size="120" shape="square" :src="head_icon" />
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      head_icon: "./img/head.png"
    };
  }
  // props: {
  //   msg: String
  // }
};
</script>

<style>
.avatar {
  border: solid 4px;
}
</style>
